import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from '@angular/router';
import {AuthService} from './services/auth';
import {of} from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class RouteGuardService implements CanActivate {

    constructor(private router: Router,
                private auth: AuthService) {
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): any {
        this.auth.isUserSignedIn()
            .subscribe({
                next: () => { },
                error: () => {
                    this.router.navigate(['/login']);
                    return false;
                }
            });
    }
}
